import React from 'react';
import TrueImpactLevelFeedbackModal from 'shared/design-system/components/TrueImpactLevelFeedbackModal';
import { BudgetFlag, IRS_SOURCE_TEXT } from './budgetFlagUtils';

interface BudgetFlagModalProps {
  open: boolean;
  flag: BudgetFlag | undefined;
  initialNote: string;
  onClose: () => void;
  onConfirm: (note: string) => void;
}

const BudgetFlagModal: React.FC<BudgetFlagModalProps> = ({
  open,
  flag,
  initialNote,
  onClose,
  onConfirm,
}) => {
  if (!flag) return null;

  return (
    <TrueImpactLevelFeedbackModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText="Save"
      initialNote={initialNote}
      placeholder={flag.notePlaceholder}
      message={
        <>
          <p className="message">{flag.message}</p>
          <p className="message">{IRS_SOURCE_TEXT}</p>
        </>
      }
    />
  );
};

export default BudgetFlagModal;
